import { BaseService } from './base.service'
import { ErrorWrapper, ResponseWrapper } from './util'

export class PhysicalPersonsService extends BaseService {
  static get entity () {
    return 'v1/physical-persons'
  }

  static async getPesonsList(searchLine) {
    let paramString = ''
    if (searchLine) {
      paramString = `?search-line=${searchLine}`
    }
    
    try {
      const response = await this.request({ auth: true }).get(`${this.entity}${paramString}`)
      return new ResponseWrapper(response, response.data)
    } catch (error) {
      console.log(error)
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getBalance(guid) {
    let paramString = ''
    if (guid) {
      paramString = `?person_guid=${guid}`
    }
    
    try {
      const response = await this.request({ auth: true }).get(`${this.entity}/balance/all${paramString}`)
      return new ResponseWrapper(response, response.data)
    } catch (error) {
      console.log(error)
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  } 

  static async getSettlements(guid) {
    let paramString = ''
    if (guid) {
      paramString = `?person_guid=${guid}`
    }
    
    try {
      const response = await this.request({ auth: true }).get(`${this.entity}/settlements/all${paramString}`)
      return new ResponseWrapper(response, response.data)
    } catch (error) {
      console.log(error)
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  } 
}